import { FC } from 'react';

import { Icon } from './Icon';
import { SvgIcon } from './SvgIcon.type';

export const IconSort: FC<SvgIcon> = (props) => (
  <Icon {...props} viewBox="0 0 24 24" name="sort">
    <path d="m8.452 4.605 3.895 4.452-.903.79L8.6 6.597V19.6H7.4V6.597l-2.843 3.25-.904-.79L7.55 4.605a.6.6 0 0 1 .903 0ZM11.653 14.944l3.896 4.451a.6.6 0 0 0 .903 0l3.895-4.451-.903-.79-2.844 3.25V4.4h-1.2v13.003l-2.844-3.25-.903.79Z" />
  </Icon>
);
